import { useEffect, useState } from "react";
import { GetTokenDecoded } from "../utils/storeUsuario";
import { BmHttp } from "../utils/Global"; // asegúrate de que esté correctamente exportado

export default function useImpagoChecker() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const checkImpago = async () => {
      try {
        const { idclinica } = GetTokenDecoded();
        const { data } = await BmHttp().get(`estado_impago?idclinica=${idclinica}`);
        if (data.aviso_impago) {
          setShowModal(true);
        }
      } catch (error) {
        console.error("Error consultando impago:", error);
      }
    };

    checkImpago(); // Al cargar

    const interval = setInterval(() => {
      checkImpago(); // Repetir cada 5 minutos
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return { showModal, setShowModal };
}
